/* eslint-disable import/no-relative-packages */
import React from "react";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getCardBodyContent } from "@qlik/qlik/src/lib/util/helpers";
import MarketoForm from "@qlik/qlik/src/components/MarketoForm/MarketoForm";

import * as styles from "./styles.module.css";

const CardTextAndForm = ({ data }) => {
    const { title, additionalConfiguration, backgroundColor, cardItems = [], customId } = data ?? {};

    const { sectionColorMapping } = getColorClassName(backgroundColor);
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "lg:py-30");

    const bodyContent = getCardBodyContent(cardItems?.[0]);

    return (
        <section className={` ${sectionSpacingClassName} ${sectionColorMapping.bgColor || "bg-white"}`} id={customId}>
            <div className="container">
                <div className="row">
                    <div className="col-12 md:col-7 md:pr-16 md:mb-0 mb-8 pt-5 lg:pt-0">
                        {title && <h1 className="lg:mb-17 mb-5 title-2">{title}</h1>}
                        {bodyContent && <div className={`${styles.bodyContent} pt-3`}>{bodyContent}</div>}
                    </div>
                    <div className="col-12 md:col-5 pt-5 lg:pt-0">
                        <div
                            className={`px-5 py-11 lg:p-10.25  ${
                                sectionColorMapping.bgColor
                                    ? "bg-white border border-stone/50 rounded shadow-xxl"
                                    : "bg-blue"
                            }`}
                        >
                            <MarketoForm form={cardItems?.[1]} isDark={!sectionColorMapping.bgColor} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CardTextAndForm;
